// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';

import { RowWrapper, OptionalLabel } from '../styles';

type Props = {
  onChange: (key: string, value: string | boolean) => void,
  data: Object,
  t: any;
}

function Other(props: Props) {
  return (
    <RowWrapper className="row">
      <div className="col-xs-2" style={{ display: 'flex', alignItems: 'center' }}>
        <Checkbox
          label={props.t('other')}
          name="other"
          onCheck={(e, v) => props.onChange('other', v)}
          checked={props.data.other}
        />
      </div>
      { props.data.other &&
        <div className="col-xs-10">
          <OptionalLabel style={{ display: 'inline' }}>{props.t('ifOtherSpecify')}</OptionalLabel>
          <TextField
            name="others"
            onChange={(e, v) => props.onChange('others', v)}
            value={props.data.others}
          />
        </div>
      }
    </RowWrapper>
  );
}

export default translate('radioConfiguration')(Other);



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/streamConfigurationForm/Other.js